// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rule-section .v-chip.success{background-color:#119f75!important;border-color:#119f75!important}.rule-section .v-chip.success--text{color:#119f75!important;caret-color:#119f75!important}", ""]);
// Exports
module.exports = exports;
